import React, { useEffect, useState } from "react";
import "./Report.scss";
import { FaSearch } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { loadInitialData } from "../../redux/slices/housingSlice";
import { fetchHouseDetails, fetchReportData, fetchSchemesData } from "../../services/api";
import Pagination from "../../utils/Pagination";
import Loading from "../../components/Loading/Loading";
import { Link } from "react-router-dom";
import { MdOutlineRemoveRedEye } from "react-icons/md";

const Report = () => {
  const [reportData, setReportData] = useState([]);
  const [panchayatId, setPanchayatId] = useState(0);
  const [villageId, setVillageId] = useState(0);
  const [schemeData, setSchemeData] = useState([]);
  const [schemeId, setSchemeId] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [houseDetailsData, setHouseDetailsData] = useState([]);
  const [houseDetailsId, setHouseDetailsId] = useState(0);
  const [selectedBlockId, setSelectedBlockId] = useState(0);
  const [startDates, setStartDates] = useState("");
  const [endDates, setEndDates] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(loadInitialData());
    fetchTransaction();
  }, [dispatch]);

  const blocksPerPage = 10;
  const { blocks, panchayats, villages } = useSelector(
    (state) => state.housingData
  );


  const filteredBlocks = Array.isArray(reportData)
    ? reportData.filter(
      (block) =>
        block.beneficiary &&
        block.beneficiary.toLowerCase().includes(searchTerm.toLowerCase())
    )
    : [];

  const pageCount = Math.ceil(filteredBlocks.length / blocksPerPage);

  const getCurrentPageBlocks = () => {
    const startIndex = currentPage * blocksPerPage;
    const endIndex = startIndex + blocksPerPage;
    return filteredBlocks.slice(startIndex, endIndex);
  };

  const handleBlockChange = (event) => {
    setFilterData({
      ...filterData,
      selectedBlockIds: event.target.value
    });
  };

  const handleVillageChange = (event) => {
    setFilterData({
      ...filterData,
      villageIds: event.target.value
    });
  };

  const handlePanchayatChange = (event) => {
    setFilterData({
      ...filterData,
      panchayatIds: event.target.value
    });
  };

  const handleHouseDetailChange = (event) => {
    setFilterData({
      ...filterData,
      houseDetailsIds: event.target.value
    });
  };
  
  const handleSchemeChange = (event) => {
    setFilterData({
      ...filterData,
      schemeIds: event.target.value
    });
  };

  const [filterData, setFilterData] = useState({
    selectedBlockIds: 0,
    villageIds: 0,
    panchayatIds: 0,
    houseDetailsIds: 0,
    schemeIds:0,
  });

  const handleSearch = () => {
    setSelectedBlockId(filterData.selectedBlockIds || 0);
    setVillageId(filterData.villageIds || 0);
    setPanchayatId(filterData.panchayatIds || 0);
    setHouseDetailsId(filterData.houseDetailsIds || 0);
    setSchemeId(filterData.schemeIds || 0);
    setCurrentPage(0);
    fetchTransaction();
  };


  const fetchTransaction = async () => {
    setLoading(true);
    const params = {
      blockId: filterData.selectedBlockIds || 0,
      panchayatId: filterData.panchayatIds || 0,
      villageId: filterData.villageIds || 0,
      housedetailId: filterData.houseDetailsIds || 0,
      schemeId: filterData.schemeIds || 0,
    };
    console.log(params);
  
    try {
      const response = await fetchReportData(params);
      if (Array.isArray(response)) {
        const filteredByDate = response.filter((item) => {
          const itemDate = new Date(item.reportedDate);
          const startDate = startDates ? new Date(startDates) : null;
          const endDate = endDates ? new Date(endDates) : null;
  
          if (startDate && endDate) {
            return itemDate >= startDate && itemDate <= endDate;
          } else if (startDate) {
            return itemDate >= startDate;
          } else if (endDate) {
            return itemDate <= endDate;
          } else {
            return true;
          }
        });
  
        // Sort by reportedDate in descending order (most recent first)
        const sortedData = filteredByDate.sort((a, b) => new Date(b.reportedDate) - new Date(a.reportedDate));
  
        console.log(sortedData); // Log sorted data
  
        // Set the sorted data in the state
        setReportData(sortedData);
      } else {
        setReportData([]); // Set empty array if response is not an array
      }
    } catch (error) {
      console.error("Error fetching report data:", error);
    } finally {
      setLoading(false); // Reset loading state
    }
  };
  

  const clearFilters = () => {
    setSelectedBlockId(0);
    setPanchayatId(0);
    setVillageId(0);
    setHouseDetailsId(0);
    setSchemeId(0);
    setFilterData({
      selectedBlockIds: 0,
      villageIds: 0,
      panchayatIds: 0,
      houseDetailsIds: 0,
      schemeIds:0,
    });
    setStartDates("");
    setEndDates("");
    setSearchTerm("");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchTransaction();
  }, [selectedBlockId, panchayatId, villageId,schemeId, houseDetailsId, startDates, endDates, searchTerm]);

  console.log(houseDetailsId, filterData.houseDetailsIds);

  const fetchHouseDetailsData = async () => {
    try {
      const response = await fetchHouseDetails();
      setHouseDetailsData(response.data);
    } catch (error) {
      console.error("Error fetching house details data:", error);
    }
  };
  
  const fetchSchemes = async () => {
    try {
      const response = await fetchSchemesData();
      setSchemeData(response.data);
    } catch (error) {
      console.error("Error fetching house details data:", error);
    }
  };


  useEffect(() => {
    fetchSchemes();
    fetchHouseDetailsData();
  }, []);

  

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    return new Intl.DateTimeFormat("en-GB", options).format(new Date(dateString));
  };

  const getSortedOptions = (options) => {
    return options
      .filter(option => option && option.name && option.name.trim() !== "")
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(option => (
        <option key={option.id} value={option.id}>
          {option.name}
        </option>
      ));
  };
  return (
    <div className="houseState ">
      {loading && <Loading />}
      {!loading && (
        <div className="houseState-container box-shadow">
          <div className="container-head p-15">
            <h2>Report</h2>
          </div>
          <div className="table-filters">
            <div className="search-filter">
              <label htmlFor="searchName">
                <FaSearch />
              </label>
              <input
                type="text"
                id="searchName"
                placeholder="Search by Report"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="filter-date">
              <input
                type="date"
                name="startDates"
                className="f-date"
                value={startDates}
                onChange={(e) => setStartDates(e.target.value)}
              />
              <input
                type="date"
                name="endDates"
                className="f-date"
                value={endDates}
                onChange={(e) => setEndDates(e.target.value)}
              />
            </div>
            <div className="dropdown-filters flexColumn">
              <div className="dropdown-filter">
                <select
                  onChange={handleBlockChange}
                  value={filterData.selectedBlockIds}
                >
                  <option value="">Select Block</option>
                  {getSortedOptions(blocks)}
                </select>
                <select
                  onChange={handlePanchayatChange}
                  value={filterData.panchayatIds}
                >
                  <option value="">Select Panchayat</option>
                  {getSortedOptions(panchayats)}
                </select>
                <select
                  onChange={handleVillageChange}
                  value={filterData.villageIds}
                >
                  <option value="">Select Village</option>
                  {getSortedOptions(villages)}
                </select>
                <select
                  onChange={handleHouseDetailChange}
                  value={filterData.houseDetailsIds}
                >
                  <option value="">Select House Details</option>
                  {houseDetailsData.map((housedetails) => (
                    <option key={housedetails.id} value={housedetails.id}>
                      {housedetails.beneficiary}
                    </option>
                  ))}
                </select>
                <select
                  onChange={handleSchemeChange}
                  value={filterData.schemeIds}
                >
                  <option value="">Select Schemes</option>
                  {schemeData.map((scheme) => (
                    <option key={scheme.id} value={scheme.id}>
                      {scheme.name}
                    </option>
                  ))}
                </select>
               
              </div>
              <div className="dropdown-btns">
              <button className="s-btns" onClick={handleSearch}>
                  Search
                </button>
                <button onClick={clearFilters} className="btns" title="Clear Filter">
                  Clear
                </button>
              </div>
            </div>
          </div>
          <div className="houseState-content" style={{ overflowX: "auto" }} >
            <div className="table-container" >
              <table className="custom-table">
                <thead>
                  <tr>
                    <th>Block Name</th>
                    <th>Panchayat Name</th>
                    <th>Scheme Name</th>
                    <th>ID No</th>
                    <th>Beneficiary Name</th>
                    <th>Target </th>
                    <th>Stage</th>
                    <th>Steel</th>
                    <th>Cement</th>
                    <th>SNA Payment</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="11" className="text-center">
                        Loading...
                      </td>
                    </tr>
                  ) : getCurrentPageBlocks().length > 0 ? (
                    getCurrentPageBlocks().map((item) => (
                      <tr key={item.transactionId}>
                        <td className="text-left">{item.blockName}</td>
                        <td className="text-left">{item.panchayatName}</td>
                        <td className="text-left">{item.schemeName}</td>
                        <td className="text-center">{item.transactionId}</td>
                        <td className="text-left">{item.beneficiary}</td> 
                        <td className="text-center">{'0'}</td>
                        <td className="text-left">{item.houseStatus}</td>
                        <td className="text-center">{item.materialSteel}</td>
                        <td className="text-center">{item.materialCement}</td>
                        {/* <td className="text-left">{formatDate(item.reportedDate)}</td> */}
                        <td className="text-center">{item.nmrWages}</td>
                       
                       
                        
                        <td className="icons text-center">
                            <Link
                              to={`/report-view/${item.transactionId}`} 
                            >
                              <MdOutlineRemoveRedEye title="View" style={{ cursor: 'pointer' }} />
                            </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="11" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <Pagination
                pageCount={pageCount}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Report;
